import Vue from 'vue';
import axios from 'axios';
import Constants from '@/plugins/constants';
const apiClient = axios.create({
  baseURL: Constants.MAINURL,
  withCredentials: true,
  headers: {
    Accept: 'application/json',
    'Content-Type': 'application/json',
  },
});
var options = {
  persist: true,
};
Vue.use(options);
apiClient.interceptors.request.use(
  function (config) {
    config.headers['Content-Type'] = 'application/json';
    return config;
  },
  function (error) {
    return Promise.reject(error);
  },
);

const state = {
  error400: false,
  error: '',
  successFlag: false,
  token: '',
  stations: [],
  allStations: [],
  totalPages: 0,
  totalRecords: 0,
  station: null,
  errorStatus: null,
};
const getters = {
  getApiLoad_93: (state) => {
    return state.successFlag;
  },
};
const mutations = {
  set_error400(state, error) {
    state.error400 = error;
  },
  SET_Status(state, status) {
    state.successFlag = status;
  },
  SET_Error(state, error) {
    state.error = error;
  },
  SET_errorStatus(state, error) {
    state.errorStatus = error;
  },
  SET_Stations(state, stations) {
    state.stations = stations.items;
    state.totalPages = stations.totalPages;
    state.totalRecords = stations?.totalRecords ?? 0;
  },
  SET_AllStations(state, stations) {
    state.allStations = stations;
  },
  SET_Station(state, station) {
    state.station = station;
  },
};
const actions = {
  errorStation({ commit }, temperror) {
    var error = temperror;
    if (error) {
      if (error.response) {
        if (error.response.status) {
          if (error.response.status == 401) {
            commit('SET_errorStatus', true);
            commit('set_error400', false);
          } else if (error.response.status == 400) {
            commit('SET_errorStatus', false);
            commit('set_error400', true);
          } else {
            commit('SET_errorStatus', false);
            commit('set_error400', false);
          }
        }
        if (error.response.data) {
          commit('SET_Error', error.response.data.message);
        } else {
          commit('SET_Error', 'عدم ارتباط با سرور');
        }
      } else {
        commit('SET_errorStatus', false);
        commit('set_error400', false);
        commit('SET_Error', 'خطا در برقراری ارتباط با سرور');
      }
      commit('SET_Status', false);
    } else {
      commit('SET_Error', 'خطا امنیتی');
    }
  },
  getAllStations({ commit, dispatch, rootState }) {
    return apiClient
      .get('/Stations/All', {
        headers: { 'X-CSRF-Token': rootState.loginModule.csrf },
      })
      .then((response) => {
        commit('SET_AllStations', response.data);
        commit('SET_Status', true);
      })
      .catch((error) => {
        dispatch('errorStation', error);
      });
  },
  getStationsWithPagination(
    { commit, dispatch, rootState },
    { pageNumber, pageSize, title, code, zoneId },
  ) {
    var url = '/Stations/AllPagination?pageNumber=' + pageNumber + '&pageSize=' + pageSize;
    if (title) {
      url += '&Title=' + title;
    }
    if (code) {
      url += '&Code=' + code;
    }
    if (zoneId) {
      url += '&ZoneId=' + zoneId;
    }
    return apiClient
      .get(url, { headers: { 'X-CSRF-Token': rootState.loginModule.csrf } })
      .then((response) => {
        commit('SET_Stations', response.data);
        commit('SET_Status', true);
      })
      .catch((error) => {
        dispatch('errorStation', error);
      });
  },
  addStation({ commit, dispatch, rootState }, data) {
    return apiClient
      .post('/Stations', data, {
        headers: { 'X-CSRF-Token': rootState.loginModule.csrf },
      })
      .then(() => {
        commit('SET_Status', true);
      })
      .catch((error) => {
        dispatch('errorStation', error);
      });
  },
  getStation({ commit, dispatch, rootState }, id) {
    return apiClient
      .get('/Stations/ById?stationId=' + id, {
        headers: { 'X-CSRF-Token': rootState.loginModule.csrf },
      })
      .then((response) => {
        commit('SET_Station', response.data);
        commit('SET_Status', true);
      })
      .catch((error) => {
        dispatch('errorStation', error);
      });
  },
  editStation({ commit, dispatch, rootState }, data) {
    return apiClient
      .post('/Stations/Edit', data, {
        headers: { 'X-CSRF-Token': rootState.loginModule.csrf },
      })
      .then(() => {
        commit('SET_Status', true);
      })
      .catch((error) => {
        dispatch('errorStation', error);
      });
  },
  deleteStation({ commit, dispatch, rootState }, id) {
    return apiClient
      .post(
        '/Stations/Remove?stationId=' + id,
        {},
        { headers: { 'X-CSRF-Token': rootState.loginModule.csrf } },
      )
      .then(() => {
        commit('SET_Status', true);
      })
      .catch((error) => {
        dispatch('errorStation', error);
      });
  },
};
export default {
  mutations,
  getters,
  state,
  actions,
};
